<template>
  <TransitionGroup
    :gtm-tab-name="gtmTabName"
    :name="slideTransition"
    class="secondary-tab"
    tag="div"
  >
    <div v-if="heading" :key="tabHeadingKey" class="h1 secondary-tab-heading">
      {{ heading }}
    </div>
    <slot :key="tabContentKey" />
    <NavigationElementContact key="secondary-tab-contact" />
  </TransitionGroup>
</template>

<script setup lang="ts">
const props = defineProps<{ gtmTabName?: string; heading?: string }>()
const tabHeadingKey = computed(() => `${props.heading}-secondary-tab-heading`)
const tabContentKey = computed(() => `${props.heading}-secondary-tab-content`)
const mobileNavStore = useMobileNavStore()
const { slideTransition } = storeToRefs(mobileNavStore)
</script>

<style lang="less">
.secondary-tab {
  .flex();
  .flex-col();

  height: 100%;
  width: 100%;

  .secondary-tab-heading {
    padding: 0 @gutter-lg;
  }

  .secondary-tab-list {
    height: 100%;
    overflow-y: auto;
    padding: 0 @gutter-lg;

    > a {
      .block();
      .relative();

      color: @color-fill-text;
      border-bottom: solid @2px @color-border;
      padding: @gutter-sm @gutter @gutter-sm 0;

      &:last-child {
        border: none;
        margin-bottom: @36px;
      }

      > * {
        pointer-events: none;
      }

      > .icon {
        .absolute();

        top: 50%;
        transform: translate(0, -50%);
        right: 0;
        color: @color-fill-less-muted;

        &.icon--story {
          transform: none;
          top: @3px;
        }
      }

      > span,
      > .event-desc > span {
        .font-body();
        .font-medium();
        .font-size(17, 24);
      }

      &.event-card {
        .flex();
      }

      .event-date-overlay {
        .relative();

        left: 0;
        top: 0;
        margin-right: @gutter;
      }
    }

    .location {
      padding: @2px 0;
    }

    .location,
    .location .icon {
      .font-size(12, 18);

      color: @color-fill-text-alt;
    }
  }

  .secondary-tab-search {
    height: 100%;

    form {
      .flex();
    }

    .formkit-outer {
      margin-bottom: 0;

      &:first-child {
        flex-basis: 100%;
      }

      .formkit-wrapper,
      .formkit-element,
      .search-button {
        height: 100%;
      }
      .search-button > * {
        pointer-events: none;
      }
    }

    .formkit-outer[data-family='text'] .formkit-input-element--search {
      margin-bottom: 0;

      input {
        padding-left: @gutter-xxl;
        padding-right: @gutter-xs;
        border: solid @1px @color-fill-muted;
        background-color: @color-fill-normal;

        &::-webkit-search-cancel-button {
          background-position: top left;
          width: @30px;
          height: @30px;
        }
      }
      &::before {
        left: @gutter;
        right: auto;
      }
    }
  }

  .contact {
    background-color: @color-fill-normal;
    border-top: @color-border solid;
  }
}

// Transitions
.slide-left-enter-active,
.slide-right-enter-active {
  transition: transform 0.25s cubic-bezier(0.4, 0.6, 0.2, 1);
}
.slide-left-enter-from,
.slide-right-leave-to {
  transform: translateX(75%);
}
.slide-left-leave-to,
.slide-right-enter-from {
  transform: translateX(-75%);
}
</style>
